import React, { useEffect } from 'react';
import { makeStyles, Container, Grid } from '@material-ui/core';
import {
  BackNavAdmin,
  BackNavAdminMenus,
  BackNavAdminButtons,
  DialogAllCreateIdea,
  ChallengeFollowUp,
  ChallengeIdeaTable,
} from '../../components';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  ideaCreateActions,
  ideaCreateDialogsActions,
  challengeActions,
} from '../../actions';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(3),
  },
}));

function ChallengeFollowUpPage() {
  const classes = useStyles();
  const { id } = useParams();
  const dispatch = useDispatch();
  const {
    challengeDetail,
    challengeTableIdeas: { ideas, paging },
  } = useSelector((state) => state.challenge);
  const {
    typeProfile: { type },
  } = useSelector((state) => state.user);

  const { t } = useTranslation();
  useEffect(() => {
    dispatch(challengeActions.getChallengeById(id));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id]);

  useEffect(() => {
    if (type === 'colaborator') {
      dispatch(challengeActions.setFilterColaborator());
      const status = [
        'CONCLUDED',
        'PATENT_PENDING',
        'EXECUTION_QUEUE',
        'EXECUTION',
        'QUALIFIED',
      ];

      dispatch(
        challengeActions.getIdeasChallenge(
          id,
          1,
          paging.sort,
          paging.limit,
          status
        )
      );
    } else {
      const status = [
        'CONCLUDED',
        'PATENT_PENDING',
        'EXECUTION_QUEUE',
        'EXECUTION',
        'QUALIFIED',
        'AWAITING_QUALIFICATION',
        'EXECUTING'
      ];
      dispatch(
        challengeActions.getIdeasChallenge(
          id,
          1,
          paging.sort,
          paging.limit,
          paging.statusCode
        )
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function createIdea() {
    const challenge = {
      _id: challengeDetail._id,
      name: challengeDetail.name,
      createdAt: challengeDetail.createdAt,
      status: true,
    };

    dispatch(ideaCreateActions.setChallenge(challenge));
    dispatch(ideaCreateActions.setIdeaCreateChallenge());
    dispatch(ideaCreateDialogsActions.openDialogTitleDescription());
  }

  return (
    <div>
      <DialogAllCreateIdea challenge />
      <BackNavAdmin title={challengeDetail.name} pathname="/challenges">
        <BackNavAdminButtons type={type} id={id} createIdea={createIdea} />
      </BackNavAdmin>
      <BackNavAdminMenus type={type} id={id} />
      <Container maxWidth="lg" className={classes.container}>
        < ChallengeFollowUp 
        dueDate = {
          challengeDetail.dueDate
        }
        daysLeft = {
          challengeDetail.daysLeft
        }
        ideas = {
          challengeDetail.ideas
        }
        ups = {
          challengeDetail.ups
        }
        comments = {
          challengeDetail.comments
        }
        user = {
          challengeDetail.topUser
        }
        area = {
          challengeDetail.topArea
        }
        />

        {ideas && ideas.length > 0 && (
          <Grid container>
            <Grid item xs={12}>
              <ChallengeIdeaTable
                ideas={ideas}
                paging={paging}
                id={id}
              ></ChallengeIdeaTable>
            </Grid>
          </Grid>
        )}
      </Container>
    </div>
  );
}

export { ChallengeFollowUpPage };
